var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        ref: "socialLoginForm",
        attrs: {
          action: "/social-login/redirect/" + _vm.selectedsocialOption,
          method: "POST",
        },
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "redirect_to" },
          domProps: { value: _vm.$route.path },
        }),
      ]
    ),
    _vm._v(" "),
    _vm.generalSettings.social_login.facebook == 1
      ? _c(
          "button",
          {
            staticClass: "lh-0 me-3",
            on: {
              click: function ($event) {
                return _vm.socialAuth("facebook")
              },
            },
          },
          [_c("img", { attrs: { src: _vm.socialIcons.facebook, alt: "" } })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.generalSettings.social_login.twitter == 1
      ? _c(
          "button",
          {
            staticClass: "lh-0 me-3",
            on: {
              click: function ($event) {
                return _vm.socialAuth("twitter")
              },
            },
          },
          [_c("img", { attrs: { src: _vm.socialIcons.twitter, alt: "" } })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.generalSettings.social_login.google == 1
      ? _c(
          "button",
          {
            staticClass: "lh-0",
            on: {
              click: function ($event) {
                return _vm.socialAuth("google")
              },
            },
          },
          [_c("img", { attrs: { src: _vm.socialIcons.google, alt: "" } })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }